if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"admin","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4((15|68|78|9)2|087|206)|5(137|254|635|730)|7(063|61|635|84)|8(016|111|968)|9(256|367|444)|16|1825|2301|2873|3349|6587)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}